/**
 * Human-readable lot code helpers. Codes look like `L-20260805-003`:
 * the date the bag was created plus that day's bag number. The counter
 * lives in the `lotCounters/{YYYYMMDD}` doc and is incremented in the
 * same transaction that creates the lot, so codes are unique per day.
 * Dates are pinned to the factory calendar (America/New_York) — "today"
 * is the Boston facility's today, so the code's date can't shift with
 * whatever time zone the printing machine happens to be set to.
 */
import { FACTORY_TZ, fmtInTZ } from '../../shipping/time-utils.js';

function pad(value, width) {
  return String(value).padStart(width, '0');
}

/**
 * Date key used for both the code and the `lotCounters` doc ID.
 * @param {Date} instant
 * @returns {string} e.g. "20260805"
 */
export function lotDateKey(instant) {
  return fmtInTZ(instant, FACTORY_TZ, 'yyyyMMdd');
}

/**
 * Display code for a lot label.
 * @param {Date} instant
 * @param {number} count - 1-based bag number for that day.
 * @returns {string} e.g. "L-20260805-003"
 */
export function formatLotCode(instant, count) {
  return `L-${lotDateKey(instant)}-${pad(count, 3)}`;
}
